import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { CaretUp } from "styled-icons/fa-solid/CaretUp";
import { CaretDown } from "styled-icons/fa-solid/CaretDown";

const Minus = styled(CaretDown)`
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  ${props =>
    props.active &&
    css`
      color: #5d9cec;
    `};
`;
const Plus = styled(CaretUp)`
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  ${props =>
    props.active &&
    css`
      color: #5d9cec;
    `};
`;

const Input = styled.input`
  width: 30px;
  padding: 3px;
  padding-top: 0px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  border: 1px solid #ddd;
  text-align: center;
`;

export default class NumberPicker extends React.Component {
  increase = _ => this.props.onChange(this.props.value + 1);
  decrease = _ => this.props.onChange(Math.max(0, this.props.value - 1));
  onChange = e => this.props.onChange(Number(e.target.value));

  onTyping = e => {
    const value = e.target.value ? Number(e.target.value) : e.target.value;
    this.props.onChange(value);
  };

  render() {
    const { value } = this.props;
    const active = value > 0;
    return (
      <Fragment>
        <Minus size={20} onClick={this.decrease} active={active} />
        <Input value={value} onChange={this.onTyping} onBlur={this.onChange} />
        <Plus size={20} onClick={this.increase} active={active} />
      </Fragment>
    );
  }
}

NumberPicker.propTypes = {
  value: PropTypes.number,
  onCHange: PropTypes.func
};
